export default function Blog(props) {
	return <>My Blog</>;
}
